import Model from './Model';

import { AccountUserDetails } from 'Api/SiteApi/Response/AccountApi';

export default class UserDetails extends Model {
    readonly id: number;
    readonly address: string;
    readonly address2: string;
    readonly balance: number;
    readonly birthday: string | null;
    readonly city: string;
    readonly country: string;
    readonly email: string | null;
    readonly gender: string | null;
    readonly isConfirmed: boolean;
    readonly isReseller: boolean;
    readonly lastName: string;
    readonly name: string;
    readonly phone: string | null;
    readonly postalCode: string;
    readonly resellerDebit: number;
    readonly resellerWantsToBecome: number;
    readonly state: string;
    readonly timezone: string;
    readonly socialProvider: string;

    /* eslint-disable camelcase */
    constructor(props: AccountUserDetails) {
        super();

        this.id = props.id ?? 0;
        this.address = props.address ?? '';
        this.address2 = props.address2 ?? '';
        this.balance = props.balance;
        this.birthday = props.birthday;
        this.city = props.city ?? '';
        this.country = props.country ?? '';
        this.email = props.email;
        this.gender = props.gender;
        this.isConfirmed = !!props.is_confirmed;
        this.isReseller = !!props.is_reseller;
        this.lastName = props.last_name ?? '';
        this.name = props.name ?? '';
        this.phone = props.phone;
        this.postalCode = props.postal_code ?? '';
        this.resellerDebit = props.reseller_debit;
        this.resellerWantsToBecome = props.reseller_wants_to_become;
        this.state = props.state ?? '';
        this.timezone = props.timezone ?? '';
        this.socialProvider = props.social_provider;
    }

    getFullName(): string {
        return [this.name, this.lastName].filter((part) => part !== '').join(' ');
    }

    /**
     * Get parsed user address (address 1 + address 2 separated with space)
     */
    getAddress(): string {
        let address = this.address;

        if (this.address2 !== '') {
            address += ` ${this.address2}`;
        }

        return address;
    }

    getAddressWithoutHouse(): string {
        const address = this.getAddress();
        return address.replace(/\b\d{1,5}[A-Za-z/-]?\b/, '').trim();
    }

    getHouseNumber(): string {
        const address = this.getAddress();
        const parts = address.match(/\b\d{1,5}[A-Za-z/-]?\b/);
        return parts ? parts[0].trim() : '';
    }
}
